import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=8bd8f52c&scoped=true"
import script from "./serve.vue?vue&type=script&lang=js"
export * from "./serve.vue?vue&type=script&lang=js"
import style0 from "./serve.vue?vue&type=style&index=0&id=8bd8f52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd8f52c",
  null
  
)

export default component.exports